export const CAREERS_URL = 'https://thl.stackmap-os.com/careers/thl/';
export const BLOG_URL = 'http://thl.stackmap-os.com/blog/thl';
